import { useParsePrescriptionMutation } from "../app/vaApi/vaApi";
import { prescriptionFromExtract } from "../helpers/prescriptionExtract";

export function useParsePrescription() {
  const [parsePrescription, state] = useParsePrescriptionMutation();

  const parse = async ({
    file,
    parseId,
    orderedLensType,
    prescriptionFileUrl,
    prescriptionFileKey,
  } = {}) => {
    try {
      const result = await parsePrescription({
        file,
        parseId,
        orderedLensType,
        prescriptionFileUrl,
        prescriptionFileKey,
      }).unwrap();
      return prescriptionFromExtract(result, {
        fileName: file?.name || null,
        fileUrl: prescriptionFileUrl || null,
      });
    } catch (err) {
      throw {
        ...err,
        data: {
          ...err?.data,
          message:
            err?.data?.message ||
            "Could not read prescription. Enter values manually and compare the file.",
        },
      };
    }
  };

  return {
    parse,
    isParsing: state.isLoading,
    error: state.error,
    reset: state.reset,
  };
}
